import { Fragment } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import styles from './styles.scss'

/**
 *
 * @param {string} props.className customize style of component
 */
const InformationBox = ({ className, ...rest }) => {
  const classes = clsx('pml-info-box', className)

  return (
    <Fragment>
      <style jsx>{styles}</style>
      <div className={classes} {...rest} />
    </Fragment>
  )
}

InformationBox.defaultProps = {
  className: undefined,
}

InformationBox.propTypes = {
  className: PropTypes.string,
}

export default InformationBox
